// extracted by mini-css-extract-plugin
module.exports = {"floatingMenu":"TransactionInfoLink_floatingMenu_1VYgs","btnHolder":"TransactionInfoLink_btnHolder_24QEs","badge":"TransactionInfoLink_badge_3zBzV"};